module.exports = __webpack_public_path__ + "static/media/slogo.11a758c9.png";